'use strict';

function delCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// hide dropdown panels on click of anywhere in ng-app\
module.exports = /*@ngInject*/
function() {
    return {
        link: function(scope, element, attrs) {
            element.bind('click', function() {
                window.cmCreatePageElementTag('USER-SIGNOUT', 'HEADER');

                jQuery.ajax({
                    url: '/rest/bean/uo/commerce/integrations/ProfileIntegrationService/handleRegisteredUserLogout?atg-rest-depth=7',
                    type: 'post'
                })
                .always(function() {
                    delCookie('UOCCII:');
                    delCookie('items');
                    delCookie('JSESSIONID');
                    delCookie('OrderIdCookie');

                    jQuery('form[name=mobile-logout]').submit();
                });
                return false;
            });
        }
    };
};
